/**
 * Azure Application Insights Configuration
 *
 * This file contains the configuration for Azure Application Insights SDK.
 * The connection string should be provided via environment variable.
 */

export const appInsightsConfig = {
  connectionString: import.meta.env.VITE_APPLICATIONINSIGHTS_CONNECTION_STRING,
  enableAutoRouteTracking: true, // Automatically track route changes
  disableAjaxTracking: false, // Track AJAX calls
  enableCorsCorrelation: true, // Enable CORS correlation for distributed tracing
  enableRequestHeaderTracking: true,
  enableResponseHeaderTracking: true,
  autoTrackPageVisitTime: true, // Track time spent on each page
  disableFetchTracking: false, // Track fetch calls
  correlationHeaderExcludedDomains: [] as string[], // Domains to exclude from correlation headers
  disableFlushOnBeforeUnload: true, // Prevents using the legacy unload event
  disableFlushOnUnload: true        // Prevents using the legacy unload event
}

export const isAppInsightsEnabled = (): boolean => {
  return !!appInsightsConfig.connectionString
}
